document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-set-lang]');
  if (!btn) return;
  var lang = btn.getAttribute('data-set-lang');
  document.documentElement.setAttribute('data-lang', lang);
  try { localStorage.setItem('dc-lang', lang); } catch (err) {}
});

document.addEventListener('click', function (e) {
  var f = e.target.closest('[data-filter]');
  if (!f) return;
  var bar = f.closest('[data-filters]');
  var grid = document.querySelector('[data-grid]');
  if (!grid) return;
  var want = f.getAttribute('data-filter');
  bar.querySelectorAll('[data-filter]').forEach(function (b) {
    b.setAttribute('aria-pressed', String(b === f));
  });
  grid.querySelectorAll('[data-tags]').forEach(function (item) {
    var tags = (item.getAttribute('data-tags') || '').split(/\s+/);
    item.style.display = (want === 'all' || tags.indexOf(want) > -1) ? '' : 'none';
  });
});

document.addEventListener('click', function (e) {
  var menu = document.querySelector('[data-mobile-menu]');
  var btn = document.querySelector('[data-menu-toggle]');
  if (!menu || !btn) return;
  if (e.target.closest('[data-menu-toggle]')) {
    var open = menu.hasAttribute('hidden');
    if (open) { menu.removeAttribute('hidden'); } else { menu.setAttribute('hidden', ''); }
    btn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    return;
  }
  if (e.target.closest('[data-menu-close]') || e.target === menu) {
    menu.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
});

/* product variant picker */
(function(){
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var data = root.querySelector('[data-pdp-variants]');
  var select = root.querySelector('[data-pdp-select]');
  if (!data || !select) return;
  var variants = JSON.parse(data.textContent);
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  root.addEventListener('click', function(e){
    var btn = e.target.closest('.pdp__opts .pdp__opt');
    if (!btn) return;
    var group = btn.parentNode;
    group.querySelectorAll('.pdp__opt').forEach(function(b){ b.classList.remove('pdp__opt--on'); b.setAttribute('aria-pressed','false'); });
    btn.classList.add('pdp__opt--on'); btn.setAttribute('aria-pressed','true');
    var chosen = [];
    root.querySelectorAll('.pdp__opts[data-option-index]').forEach(function(g){
      var on = g.querySelector('.pdp__opt--on');
      chosen[+g.dataset.optionIndex] = on ? on.dataset.value : null;
    });
    var v = variants.find(function(x){ return x.options.every(function(o,i){ return chosen[i] == null || o === chosen[i]; }); });
    if (!v) return;
    select.value = String(v.id);
    select.dispatchEvent(new Event('change', { bubbles: true }));
    var price = root.querySelector('[data-pdp-price]');
    if (price && v.price > 0) price.textContent = v.price_fmt + (cur ? ' ' + cur : '');
    var mo = root.querySelector('[data-pdp-mo]');
    if (mo) mo.textContent = v.mo_fmt;
    root.querySelectorAll('.affirm-as-low-as').forEach(function(el){ el.setAttribute('data-amount', v.price); });
    if (window.affirm && affirm.ui && affirm.ui.ready) affirm.ui.ready(function(){ affirm.ui.refresh(); });
    var add = root.querySelector('[data-pdp-add]');
    if (add) { add.disabled = !v.available; add.querySelector('[data-lbl-add]').hidden = !v.available; add.querySelector('[data-lbl-sold]').hidden = v.available; }
    var url = new URL(location.href); url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url.toString());
  });
})();
